import { makeStyles, shorthands } from "@fluentui/react-components";

export const useHomeStyles = makeStyles({
  root: {
    color: "#707070",
    display: "flex",
    flexDirection: "column",
    ...shorthands.margin("12px", "0", "0", "0"),
  },
  mainTitle: {
    color: "#242424",
  },
  logoBg: {
    backgroundColor: "#F5F5F5",
    display: "flex",
    justifyContent: "center",
    ...shorthands.padding("108px", "0"),
  },
  dataContainer: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("32px"),
    paddingTop: "32px",
    marginBottom: "8px",
  },
  paragraphsContainer: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("3px"),
  },
  startButton: {
    alignSelf: "flex-end",
  },
  appProdVersion: {
    color: "#d3d3d3",
    fontWeight: "semibold",
    fontSize: "11px",
  },
  appSandboxVersion: {
    color: "#47d5a8",
    fontWeight: "semibold",
    fontSize: "11px",
  },
});
